/* More Images gallery (snippets/ec-gallery.liquid) — opens tiles in the theme's PhotoSwipe viewer.
   Falls back to the plain link (full-size image) if PhotoSwipe isn't available. */
if (!customElements.get('ec-gallery')) {
  class EcGallery extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-ec-index]'));
      if (!this.links.length) return;
      this.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-ec-index], [data-ec-open]');
        if (!trigger || !this.contains(trigger)) return;
        const index = Number(trigger.dataset.ecIndex ?? trigger.dataset.ecOpen) || 0;
        if (this.open(index)) e.preventDefault();
      });
    }

    // Overflow tiles aren't on screen, so animate them from the "+N" tile instead
    thumbFor(i) {
      const link = this.links[i];
      if (link && link.offsetParent) return link;
      const shown = this.links.filter((l) => l.offsetParent);
      return shown[shown.length - 1] || this.links[0];
    }

    open(index) {
      const pswpEl = document.querySelector('.pswp');
      if (!pswpEl || typeof window.PhotoSwipe !== 'function' || typeof window.PhotoSwipeUI_Default !== 'function') {
        return false;
      }

      const items = this.links.map((link) => {
        const img = link.querySelector('img');
        return {
          src: link.href,
          msrc: img ? img.currentSrc || img.src : undefined,
          w: Number(link.dataset.w) || 1600,
          h: Number(link.dataset.h) || 1200,
          title: img ? img.alt : '',
        };
      });

      const gallery = new window.PhotoSwipe(pswpEl, window.PhotoSwipeUI_Default, items, {
        index,
        history: false,
        shareEl: false,
        captionEl: false,
        counterEl: false,
        closeOnScroll: false,
        pinchToClose: false,
        preloaderEl: false,
        bgOpacity: 0.94,
        showHideOpacity: true,
        getThumbBoundsFn: (i) => {
          const thumb = this.thumbFor(i);
          const rect = thumb.getBoundingClientRect();
          const y = window.pageYOffset || document.documentElement.scrollTop;
          return { x: rect.left, y: rect.top + y, w: rect.width };
        },
      });
      gallery.init();
      return true;
    }
  }

  customElements.define('ec-gallery', EcGallery);
}
